import { render, staticRenderFns } from "./stuExam.vue?vue&type=template&id=af62d80c&scoped=true"
import script from "./stuExam.vue?vue&type=script&lang=js"
export * from "./stuExam.vue?vue&type=script&lang=js"
import style0 from "./stuExam.vue?vue&type=style&index=0&id=af62d80c&prod&lang=less&scoped=true"
import style1 from "./stuExam.vue?vue&type=style&index=1&id=af62d80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af62d80c",
  null
  
)

export default component.exports